__turbopack_context__.v({
  "className": "GG231W_className",
  "variable": "GG231W_variable",
});
